import { LoginForm } from "@/components/forms/login";
import { useAuth } from "@/providers/auth";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function LoginPage() {
    const { authenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const handleSignin = async () => {
        localStorage.removeItem("redirect");
        navigate(from);
    };

    useEffect(() => {
        localStorage.setItem("redirect", from);
    }, [from]);

    useEffect(() => {
        if (authenticated) {
            localStorage.removeItem("redirect");
            navigate(from);
        }
    }, [authenticated, from, navigate]);

    useEffect(() => {
        document.title = `Login | Walter CRM`;
    }, []);

    return (
        <>
            <div className="flex">
                <div className="hidden h-screen w-1/2 bg-sky-200 lg:block"></div>
                <div className="flex h-screen w-full min-w-[500px] items-center justify-center bg-background lg:w-1/2">
                    <div className="w-full max-w-[350px] p-4">
                        <h1 className="mb-4 text-2xl font-medium">Walter CRM</h1>
                        <LoginForm onSignIn={handleSignin} />
                    </div>
                </div>
            </div>
        </>
    );
}
